import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroller';
import moment from 'moment';
import Header from '../../../../components/Header';
import { NO_IMAGE_URL } from '../../../../utils/constants';
import StudentCard from '../../../../components/StudentCard';
import StudentSolutionDetails from './Teacher.StudentSolutionDetails';

export default function StudentList({
  title,
  onBack,
  studentList,
  fetchMore,
  hasMore,
  isDataLoading,
  setIsDataLoading
}) {
  const [selectedStudent, setSelStu] = useState(null);
  return (
    <div style={{ marginTop: 20 }}>
      {selectedStudent === null ? (
        <>
          <Header title="Student Answers" onBack={onBack} />
          <Card style={{ maxHeight: '500px', overflowY: 'auto' }} id="scrollableCard">
            <CardContent>
              <InfiniteScroll
                pageStart={0}
                loadMore={() => {
                  if (hasMore && !isDataLoading) {
                    fetchMore();
                    setIsDataLoading(true);
                  }
                }}
                hasMore={hasMore}
                getScrollParent={() => document.getElementById('scrollableCard')}
                loader={
                  <div className="loader" key={0}>
                    Loading ...
                  </div>
                }
                useWindow={false}
              >
                {studentList.map((sl, i) => (
                  <StudentCard
                    title={sl.studentID?.fullName ?? 'Guest User'}
                    subTitle={`Submitted on ${moment(sl.createdAt).format('DD MMM, LT')}`}
                    // TODO: need to change the imageUrl flag as per backend flag
                    avatarUrl={sl.studentID?.imageUrl ?? NO_IMAGE_URL}
                    // mark={sl.mark}
                    key={sl.id}
                    onClick={() => setSelStu(i)}
                  />
                ))}
              </InfiniteScroll>
            </CardContent>
          </Card>
        </>
      ) : (
        <StudentSolutionDetails
          title={title}
          studentDetail={studentList[selectedStudent]}
          onBack={() => setSelStu(null)}
        />
      )}
    </div>
  );
}

StudentList.propTypes = {
  title: PropTypes.string,
  onBack: PropTypes.func,
  studentList: PropTypes.arrayOf(PropTypes.shape({})),
  fetchMore: PropTypes.func,
  hasMore: PropTypes.bool,
  isDataLoading: PropTypes.bool,
  setIsDataLoading: PropTypes.func
};
